import { AlertContactInput } from '../types/meta.types';

const ERRO_GENERICO = 'Não foi possível salvar o contato.';

export function mensagemDeErro(err: unknown): string {
    const detail = (err as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
    return typeof detail === 'string' ? detail : ERRO_GENERICO;
}

export function podeSalvar(c: AlertContactInput): boolean {
    return c.name.trim() !== '' && c.cell.trim() !== '';
}
